module.exports = __webpack_public_path__ + "img/blog-other-articles-img-3.8aa161cf.png";